






























































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IBrand } from "@/models/brands";
import { ITranslationFormItem, ITranslationForm } from "@/models/translations";
import { IState } from "@/store";
import HasValidation from "@/mixins/HasValidation";
import { UpmindObjectTypes } from "@/data/enums/objects";

@Component({
  components: {
    "translations-list": () =>
      import("@/components/app/global/translations/translationsList.vue")
  },
  computed: {
    ...mapState({
      translations(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.TRANSLATIONS,
          scope: this.translationsScope
        });
      },
      translationsScope(state: IState, getters) {
        return getters[`data/${DataModules.TRANSLATIONS}/scope`](this.objectId);
      },
      brand(state: IState) {
        return state.brand;
      }
    })
  }
})
export default class EditTranslationsModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Getters
  public translations!: ITranslationFormItem[];
  public translationsScope!: string[];
  public brand!: IBrand;

  // Props
  @Prop({ default: true })
  public saveOnSubmit!: boolean;

  @Prop({ default: null })
  public objectId!: string;

  @Prop({ default: () => ({}) })
  public translationsForm!: ITranslationForm;

  @Prop({ required: true })
  public objectTypeCode!: UpmindObjectTypes;

  @Prop({ required: true })
  public fieldName!: string;

  @Prop({ required: true })
  public fieldLabel!: string;

  @Prop({ default: "text" })
  public fieldType!: string;

  @Prop({ default: null })
  public brandId!: IBrand["id"];

  // Data

  public form: ITranslationForm = {
    object_type_code: "",
    object_id: "",
    translations: []
  };
  public formClone: ITranslationForm | {} = {};

  public getTranslations: ITranslationFormItem[] = [];

  public isLoading = false;
  public isReloading = false;
  public requestError = false;
  public isProcessing = false;

  public async created() {
    if (this.contentAvailable) {
      this.isLoading = true;
      this.loadData();
    }
  }

  public async loadData() {
    try {
      if (this.objectExists) await this.getObjectTranslations();

      this.form.object_type_code = this.objectTypeCode;
      this.form.object_id = this.objectId;

      this.getTranslations = (this.objectExists
        ? this.$_.map(this.translations, translation => {
            return this.$_.pick(translation, ["language_id", this.fieldName]);
          })
        : !this.$_.isEmpty(this.translationsForm)
        ? this.$_.cloneDeep(this.translationsForm.translations)
        : []) as ITranslationFormItem[];

      this.$set(
        this.form,
        "translations",
        this.$_.cloneDeep(this.getTranslations)
      );
      this.formClone = this.$_.cloneDeep(this.form);
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }
    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public get objectExists() {
    return this.objectId !== null;
  }

  public getObjectTranslations() {
    return this.$store.dispatch(`data/${DataModules.TRANSLATIONS}/get`, {
      id: this.objectId,
      objectCodeType: this.objectTypeCode,
      scope: this.translationsScope,
      vm: this
    });
  }

  public get languages() {
    return this.$_.get(this.brand, "languages", []);
  }

  public get formIsValid() {
    return !this.$_.isEqual(this.form, this.formClone);
  }

  public get formIsDisabled() {
    return (
      this.isProcessing || !this.formIsValid || this.hasErrors || this.isLoading
    );
  }

  public validateBeforeSubmit() {
    this.isProcessing = true;
    this.validate()
      .then(result => {
        if (result) return this.updateTranslations();
        throw this.$t("_sentence.form_is_not_valid");
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => (this.isProcessing = false));
  }

  public updateTranslations() {
    return new Promise<void>((resolve, reject) => {
      if (!this.saveOnSubmit) {
        this.$emit("translations-saved", this.form);
        this.$emit("close");
        return resolve();
      }

      return this.$store
        .dispatch(`data/${DataModules.TRANSLATIONS}/update`, {
          id: this.objectId,
          objectCodeType: this.objectTypeCode,
          data: this.form
        })
        .then(() => {
          this.$store.dispatch("toast/show", {
            message: this.$t("_.object_successfully_updated", {
              object: this.$t("_.translations")
            })
          });
          this.$emit("close");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public get contentAvailable() {
    return (
      this.$userCan("get_object_translation") &&
      this.$userCan("list_object_translations")
    );
  }

  public beforeDestroy() {
    this.$store.dispatch("data/bin", {
      storeModule: DataModules.TRANSLATIONS,
      scope: this.translationsScope,
      vm: this
    });
  }
}
